import { render, staticRenderFns } from "./outging.vue?vue&type=template&id=2f97aa80&scoped=true&"
import script from "./outging.vue?vue&type=script&lang=js&"
export * from "./outging.vue?vue&type=script&lang=js&"
import style0 from "./outging.vue?vue&type=style&index=0&id=2f97aa80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97aa80",
  null
  
)

export default component.exports